import { NavMarker } from 'react-rhumb';
import LocaleFormattedMessage from '../components/locales/LocaleFormattedMessage';
import { ErrorMessage } from '../components/ErrorMessage';
import { useTrackPageView } from '../hooks/use-tracking';
import { TRACKING_SCREENS } from '../constants/TrackingConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export const MissingSlug = () => {
  useTrackPageView({
    screen: TRACKING_SCREENS.MISSING_SLUG
  });
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "MISSING_SLUG_LOAD",
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      title: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
        message: "app.error.fetch.title"
      }),
      body: /*#__PURE__*/_jsx(LocaleFormattedMessage, {
        message: "app.error.fetch.body"
      })
    })
  });
};